<template>
  <v-dialog
    v-model="showNotificationDetailCopy"
    origin="center center"
    persistent
    :max-width="$vuetify.display.xs ? '100vw' : '550px'"
    :width="$vuetify.display.xs ? '100vw' : '550px'"
    class="moveHigherThanFooter"
  >
    <v-card
      :class="$vuetify.display.xs ? 'mobile-display' : ''"
      :max-width="$vuetify.display.xs ? '100vw' : '550px'"
      :width="$vuetify.display.xs ? '100vw' : '550px'"
    >
      <v-card-title class="mt-4 mb-2 text-h2">
        {{ selectedNotificationMessage.actionTitle }}
      </v-card-title>
      <v-card-text class="py-0">
        <div class="iosIframeScroller">
          <iframe
            id="content-stack-viewer"
            :src="selectedNotificationMessage.actionUrl || ''"
            title="embeddedTitle"
            class="embedded-viewer body-1"
            :class="$vuetify.display.xs ? 'iframe_mobile' : 'iframe_desktop'"
            frameBorder="0"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <div>
            <OnexButton color="primary" block @click="acceptActionClicked">
              {{ selectedNotificationMessage.actionAcceptLabel }}
            </OnexButton>
          </div>
          <div v-if="selectedNotificationMessage.actionRejectLabel">
            <OnexButton class="mt-2" color="primary" block @click="rejectActionClicked">
              {{ selectedNotificationMessage.actionRejectLabel }}
            </OnexButton>
          </div>
          <div v-if="selectedNotification.allowDismiss">
            <OnexButton class="mt-2" variant="flat" block @click="dismissActionClicked">
              {{ $t('L_skip_for_now') }}
            </OnexButton>
          </div>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState } from 'pinia';
import { OnexButton } from '@primerica/onex-ui-lib';
import { type ComponentOptions, defineComponent } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'NotificationDetail',
  components: {
    OnexButton,
  },
  props: {
    showNotificationDetail: {
      type: Boolean,
      default: false,
    },
    notificationId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      showNotificationDetailCopy: undefined as never,
    };
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      alertsAndNotifications: 'alertsAndNotifications',
    }),
    selectedNotification() {
      const alertObj = this.alertsAndNotifications.filter(
        (alert: { alertId: string }) => alert.alertId === this.notificationId
      )[0];
      return alertObj;
    },
    selectedNotificationMessage() {
      const selectedNotificationMessages = this.selectedNotification?.messages.filter(
        (message: { language: string }) => message.language === this.locale
      )[0];
      return selectedNotificationMessages;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, ['getAlerts', 'dismissAlert', 'completeAlert']),
    async acceptActionClicked() {
      await this.completeAlert({
        alertId: this.notificationId + '',
        payload: { acknowledgement: 'Y' },
      }).catch((_e: unknown) => {
        /* empty */
      });
      this.$emit('accept-action-clicked');
    },
    async rejectActionClicked() {
      await this.completeAlert({
        alertId: this.notificationId + '',
        payload: { acknowledgement: 'N' },
      }).catch((_e: unknown) => {
        /* empty */
      });
      this.$emit('reject-action-clicked');
    },
    async dismissActionClicked() {
      await this.dismissAlert(this.notificationId + '').catch((_e: unknown) => {
        /* empty */
      });
      this.$emit('dismiss-action-clicked');
    },
  },
  updated() {
    this.showNotificationDetailCopy = this.showNotificationDetail;
  },
  mounted() {
    this.showNotificationDetailCopy = this.showNotificationDetail;
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss">
#content-stack-viewer.iframe_desktop {
  width: 100%;
  height: 470px;
  display: block;
}
.moveHigherThanFooter {
  z-index: 10000 !important;
}
.v-card.mobile-display .iosIframeScroller {
  height: calc(100vh - 395px);
  overflow-y: scroll;
  position: relative;
}
#content-stack-viewer.iframe_mobile {
  width: 100%;
  height: 70vh;
}
.v-card.mobile-display {
  position: relative;
  height: calc(100vh - 395px);
  overflow-y: scroll !important;

  .v-card-actions {
    background-color: white;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
